import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tx-pagehead" }
const _hoisted_2 = { class: "tx-eyebrow" }
const _hoisted_3 = { class: "tx-actions" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "tx-announce"
}
const _hoisted_7 = { class: "tx-stats" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "tx-stat__n" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "tx-stat__n" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "tx-stat__n" }
const _hoisted_14 = {
  key: 0,
  class: "tx-stat tx-stat--danger"
}
const _hoisted_15 = { class: "tx-stat__n" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "tx-stat__n" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "tx-stat__n tx-stat__n--money" }
const _hoisted_20 = { class: "tx-grid2" }
const _hoisted_21 = {
  key: 0,
  class: "tx-card"
}
const _hoisted_22 = { class: "tx-card__head" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "tx-row__main" }
const _hoisted_26 = {
  key: 1,
  class: "tx-card"
}
const _hoisted_27 = { class: "tx-card__head" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "tx-row__main" }
const _hoisted_31 = {
  key: 0,
  class: "tx-count"
}
const _hoisted_32 = {
  key: 2,
  class: "tx-card"
}
const _hoisted_33 = { class: "tx-card__head" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "tx-row__main" }
const _hoisted_36 = {
  key: 3,
  class: "tx-card"
}
const _hoisted_37 = { class: "tx-card__head" }
const _hoisted_38 = ["href"]
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "tx-row__main" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString($setup.orgName), 1 /* TEXT */),
        _createElementVNode("h1", null, _toDisplayString($setup.state.t("dash.welcome")) + ", " + _toDisplayString($setup.firstName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        ($setup.state.modules.tickets)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: $setup.link('tickets/new'),
              "data-nav": "",
              class: "tx-btn tx-btn--primary"
            }, [
              _createVNode($setup["Icon"], {
                name: "plus",
                size: "16"
              }),
              _createTextVNode(_toDisplayString($setup.state.t("dash.new_ticket")), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        ($setup.state.modules.conversations)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: $setup.link('conversations?new=1'),
              "data-nav": "",
              class: "tx-btn tx-btn--ghost"
            }, [
              _createVNode($setup["Icon"], {
                name: "chat",
                size: "16"
              }),
              _createTextVNode(_toDisplayString($setup.state.t("dash.new_message")), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createVNode($setup["Loader"], {
      loading: $setup.loading,
      error: $setup.error,
      onRetry: $setup.load
    }, {
      default: _withCtx(() => [
        ($setup.data.announcement)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.data.announcement), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_7, [
          ($setup.data.tickets)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("a", {
                  href: $setup.link('tickets?status=Open'),
                  "data-nav": "",
                  class: "tx-stat"
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString($setup.data.tickets.open), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.state.t("dash.open")), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_8),
                _createElementVNode("a", {
                  href: $setup.link('tickets?status=Paused'),
                  "data-nav": "",
                  class: "tx-stat tx-stat--warn"
                }, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString($setup.data.tickets.waiting), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.state.t("dash.waiting")), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_10),
                _createElementVNode("a", {
                  href: $setup.link('tickets?status=Resolved'),
                  "data-nav": "",
                  class: "tx-stat tx-stat--ok"
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString($setup.data.tickets.resolved), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.state.t("dash.resolved")), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_12),
                ($setup.data.tickets.overdue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString($setup.data.tickets.overdue), 1 /* TEXT */),
                      _createElementVNode("span", null, _toDisplayString($setup.state.t("dash.overdue")), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          ($setup.data.unread_messages !== undefined)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: $setup.link('conversations'),
                "data-nav": "",
                class: "tx-stat"
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.data.unread_messages), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.state.t("dash.unread")), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_16))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.statement || [], (s) => {
            return (_openBlock(), _createElementBlock("a", {
              key: s.currency,
              href: $setup.link('account?tab=statement'),
              "data-nav": "",
              class: _normalizeClass(["tx-stat", { 'tx-stat--danger': s.overdue > 0 }])
            }, [
              _createElementVNode("span", _hoisted_19, _toDisplayString($setup.fmtMoney(s.outstanding, s.currency)), 1 /* TEXT */),
              _createElementVNode("span", null, _toDisplayString($setup.state.t("dash.outstanding")), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_18))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_20, [
          ($setup.data.tickets)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h2", null, _toDisplayString($setup.state.t("dash.recent_tickets")), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: $setup.link('tickets'),
                    "data-nav": "",
                    class: "tx-link"
                  }, _toDisplayString($setup.state.t("common.view_all")), 9 /* TEXT, PROPS */, _hoisted_23)
                ]),
                (!$setup.data.tickets.recent.length)
                  ? (_openBlock(), _createBlock($setup["Empty"], {
                      key: 0,
                      icon: "ticket"
                    }))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.tickets.recent, (t) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: t.name,
                    href: $setup.link('tickets/' + t.name),
                    "data-nav": "",
                    class: "tx-row"
                  }, [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("strong", null, "#" + _toDisplayString(t.name) + " · " + _toDisplayString(t.subject), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString($setup.fmtDate(t.modified, true)), 1 /* TEXT */)
                    ]),
                    _createVNode($setup["Badge"], {
                      status: t.status_category,
                      label: t.status
                    }, null, 8 /* PROPS */, ["status", "label"])
                  ], 8 /* PROPS */, _hoisted_24))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.data.recent_conversations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("h2", null, _toDisplayString($setup.state.t("dash.recent_messages")), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: $setup.link('conversations'),
                    "data-nav": "",
                    class: "tx-link"
                  }, _toDisplayString($setup.state.t("common.view_all")), 9 /* TEXT, PROPS */, _hoisted_28)
                ]),
                (!$setup.data.recent_conversations.length)
                  ? (_openBlock(), _createBlock($setup["Empty"], {
                      key: 0,
                      icon: "chat"
                    }))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.recent_conversations, (c) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: c.name,
                    href: $setup.link('conversations/' + c.name),
                    "data-nav": "",
                    class: "tx-row"
                  }, [
                    _createElementVNode("span", _hoisted_30, [
                      _createElementVNode("strong", null, _toDisplayString(c.subject), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString($setup.fmtDate(c.last_activity_at, true)), 1 /* TEXT */)
                    ]),
                    (c.unread)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(c.unread), 1 /* TEXT */))
                      : (_openBlock(), _createBlock($setup["Badge"], {
                          key: 1,
                          status: c.status
                        }, null, 8 /* PROPS */, ["status"]))
                  ], 8 /* PROPS */, _hoisted_29))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.data.recent_requests)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("h2", null, _toDisplayString($setup.state.t("dash.requests")), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: $setup.link('services'),
                    "data-nav": "",
                    class: "tx-link"
                  }, _toDisplayString($setup.state.t("dash.browse_services")), 9 /* TEXT, PROPS */, _hoisted_34)
                ]),
                (!$setup.data.recent_requests.length)
                  ? (_openBlock(), _createBlock($setup["Empty"], {
                      key: 0,
                      icon: "grid"
                    }))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.recent_requests, (r) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: r.name,
                    class: "tx-row"
                  }, [
                    _createElementVNode("span", _hoisted_35, [
                      _createElementVNode("strong", null, _toDisplayString(r.subject), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString(r.name), 1 /* TEXT */)
                    ]),
                    _createVNode($setup["Badge"], {
                      status: r.status
                    }, null, 8 /* PROPS */, ["status"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.data.articles && $setup.data.articles.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h2", null, _toDisplayString($setup.state.t("dash.articles")), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: $setup.link('knowledge'),
                    "data-nav": "",
                    class: "tx-link"
                  }, _toDisplayString($setup.state.t("common.view_all")), 9 /* TEXT, PROPS */, _hoisted_38)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.articles, (a) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: a.name,
                    href: $setup.link('knowledge/' + a.name),
                    "data-nav": "",
                    class: "tx-row"
                  }, [
                    _createElementVNode("span", _hoisted_40, [
                      _createElementVNode("strong", null, _toDisplayString(a.title), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString(a.excerpt), 1 /* TEXT */)
                    ])
                  ], 8 /* PROPS */, _hoisted_39))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"])
  ]))
}